import React from "react";
import styled from "styled-components";
import t from "common/i18n";

const Intro = styled.div`
	font-size: ${({ theme }) => `${theme.font.size.xxxs}`};
`;

export default ({hasConflicts, filesCount}) => {
	return (
		<Intro className="bg-source-bg-c">
			<span>{t("metadataPage.intro.openingText")}</span>
			<span> {t("metadataPage.intro.closingText")}</span>
			<br/>
			<br/>
			{hasConflicts ?
				<span><strong style={{fontWeight: "bold"}}>{t("metadataPage.intro.conflictWarning", {count: filesCount})}</strong></span>
				: null}
		</Intro>);
};
